import { Maybe } from 'graphql/jsutils/Maybe';
import {
  Input_Patientportal_UpdatePortalUserRequest,
  Patientportal_PortalUserMsg,
} from '../src/generated/graphql';

export const buildPortalUserUpdateInput = (
  user: Maybe<Patientportal_PortalUserMsg> | undefined,
): Input_Patientportal_UpdatePortalUserRequest => ({
  name: user?.name ?? undefined,
  dateOfBirth: user?.dateOfBirth?.seconds
    ? { seconds: user.dateOfBirth.seconds as number }
    : undefined,
  sex: user?.sex ?? undefined,
  contact: user?.contact ?? undefined,
  insuranceInfo: user?.insuranceInfo ?? undefined,
});
